import React from "react";
import NavButton from "../Components/Button/Nav.button";
import BaseButton from "../Components/Button/Button.base";
import logo from "../img/logo_speeker.png";

const styles = {
  page: {
    marginTop: "5rem",
  },
  logo: {

  }
};

const Unauthorized = () => (
  <div style={styles.page}>
    <h1>Accès non autorisé</h1>
    <img src={logo} alt="logo" width="150" />
    <p>Ceci est une plateforme privée, seuls les utilisateurs autorisés y ont accès.</p>
    <NavButton
      label="Connexion"
      href="/login"
      disabled={false}
    />
    <p>Si vous êtes autorisé et que vous arrivez sur cette page, tentez de vous reconnecter en vérifiant votre email.</p>
    <p>Si vous n'êtes pas autorisé, vous pouvez tester la plateforme publique de SPEEKER{' '}</p>
    <a href="https://speeker.netlify.app">
      <BaseButton label="ICI" />
    </a>    
  </div>
);
export default Unauthorized;
